import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
const Login = () => {
  return <div className="min-h-screen flex items-center justify-center bg-[#0F1115] py-12 px-4 sm:px-6 lg:px-8 relative" data-id="element-1371">
      {/* Global Grain Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-1372"></div>

      <div className="max-w-md w-full space-y-8 relative z-10" data-id="element-1373">
        <div className="text-center" data-id="element-1374">
          <h1 className="font-display text-3xl font-bold text-white" data-id="element-1375">
            Welcome back
          </h1>
          <p className="mt-2 text-gray-400" data-id="element-1376">
            Sign in to your account to continue
          </p>
        </div>
        <div className="bg-[#1a1d24] p-8 rounded-2xl border border-gray-800 shadow-lg" data-id="element-1377">
          <form className="space-y-6" data-id="element-1378">
            <div data-id="element-1379">
              <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1380">
                Email address
              </label>
              <input id="email" name="email" type="email" autoComplete="email" required className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-[#d73b3e] transition-all" placeholder="you@example.com" data-id="element-1381" />
            </div>
            <div data-id="element-1382">
              <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1383">
                Password
              </label>
              <input id="password" name="password" type="password" autoComplete="current-password" required className="w-full px-4 py-3 bg-[#0F1115] border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-[#d73b3e] transition-all" data-id="element-1384" />
            </div>
            <div className="flex items-center justify-between" data-id="element-1385">
              <div className="flex items-center" data-id="element-1386">
                <input id="remember_me" name="remember_me" type="checkbox" className="h-4 w-4 text-[#d73b3e] focus:ring-[#d73b3e] border-gray-700 rounded bg-[#0F1115]" data-id="element-1387" />
                <label htmlFor="remember_me" className="ml-2 block text-sm text-gray-300" data-id="element-1388">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-1389">
                <a href="#" className="font-medium text-[#d73b3e] hover:text-[#c02f32] transition-colors" data-id="element-1390">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div data-id="element-1391">
              <button type="submit" className="w-full px-6 py-3 bg-[#d73b3e] text-white rounded-full font-semibold hover:bg-[#c02f32] transition-all duration-300 shadow-lg" data-id="element-1392">
                Sign in
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-1393">
            <div className="relative" data-id="element-1394">
              <div className="absolute inset-0 flex items-center" data-id="element-1395">
                <div className="w-full border-t border-gray-800" data-id="element-1396" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1397">
                <span className="px-2 bg-[#1a1d24] text-gray-400" data-id="element-1398">
                  Or continue with
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-1399">
              <a href="#" className="w-full inline-flex justify-center py-3 px-4 border border-gray-800 rounded-xl bg-[#0F1115] text-sm font-medium text-gray-300 hover:bg-gray-800 transition-colors" data-id="element-1400">
                <span className="sr-only" data-id="element-1401">Sign in with GitHub</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-1402">
                  <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" data-id="element-1403" />
                </svg>
              </a>
              <a href="#" className="w-full inline-flex justify-center py-3 px-4 border border-gray-800 rounded-xl bg-[#0F1115] text-sm font-medium text-gray-300 hover:bg-gray-800 transition-colors" data-id="element-1404">
                <span className="sr-only" data-id="element-1405">Sign in with Google</span>
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-1406">
                  <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" data-id="element-1407" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-1408">
          <p className="text-sm text-gray-400" data-id="element-1409">
            Don't have an account?{' '}
            <Link to="/signup" className="font-medium text-[#d73b3e] hover:text-[#c02f32] transition-colors" data-id="element-1410">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>;
};
export default Login;